import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import CompanySelect from 'component/branch/CompanySelect'

const FIELDS = ['store', 'storeFull']

const StoreFilter = ({
  fields,
  onSubmit,
  setValueToField,
  translate,
  values,
}) => {
  const beforeOnSubmit = (event) => {
    event.preventDefault()

    onSubmit(values)
  }

  const onStoreChange = (event) => {
    event.preventDefault()

    const store = event.target.value

    setValueToField(fields.store.input.name, store)

    const optionArray = Array.from(event.target.options)

    const selectedStore = optionArray.find((option) => option.value === store)

    setValueToField(fields.storeFull.input.name, selectedStore.text)
  }

  return (
    <form onSubmit={beforeOnSubmit}>
      <Row className='margin-top-quintuple'>
        <Col xs={12}>
          <Field {...fields.store}>
            <CompanySelect {...fields.store.input} onChange={onStoreChange} />
          </Field>
        </Col>
      </Row>

      <Row className='margin-top-quintuple'>
        <Col xs={12}>
          <button
            className='button button-primary button-full'
            disabled={!values.store}
          >
            {translate('filter_button_label')}
          </button>
        </Col>
      </Row>
    </form>
  )
}

export default Form({ fields: FIELDS })(StoreFilter)

StoreFilter.propTypes = {
  fields: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}
